module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/user/shared/user-form/user-form.component.scss
// module id = ./src/app/user/shared/user-form/user-form.component.scss
// module chunks = main